export const ErrorMessages = Object.freeze({
  REQUIRED: 'This field is mandatory.',
  VALID_PHONE_NUMBER: 'Please enter a valid phone number: (###) ###-#### or ###-###-####',
  VALID_POSTAL_CODE_NUMBER: 'Please enter a valid postal code number.',
  NOT_BLANK_MESSAGE: 'This field cannot be blank.',
  VALID_EMAIL: 'Please enter a valid email address.',
  SUPPORT_SUBJECT_LENGTH: 'Subject must be 75 characters or less.',
  SUPPORT_MESSAGE_LENGTH: 'Message must be 500 characters or less.',
  NO_PROFANITY: 'Please remove any profanity from your message.',
});
